// @flow

import { cmsAxios } from '../axios-config';

const readInboxConversation = (conversationId) => {
  return cmsAxios.post(`/support-chat/conversations/${conversationId}/read`);
};

export default readInboxConversation;
